import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql`mutation go($project_id: String!, $data: [ProjectNoteInput]!){
  upsertProjectNotes(project_id: $project_id, data: $data){
    ${projectFragment}
  }
}`